import { Link } from "react-router-dom";
import "../assets/css/--component-404.css";

function StatusPage({ status = "404" }) {
  const statusConfig = {
    "404": {
      image: require("../assets/images/404 Error.png"),
      Status: require("../assets/images/404-txt.png"),
      logo: require("../assets/images/mains-logo.png"),
      title: "uh-oh... This Page is a Little Overcooked.",
      message: "Seems like this page stayed in the toaster too long. Let's get you back on track!",
      StatusCode : "404",
      btn1Class: "btn btn-primary outline",
      btn2Class: "btn btn-primary",
      btn1Text: "return to homepage",
      btn2Text: "back to menu"
    },
    "200": {
      image: require("../assets/images/Thank you.png"),
      Status: require("../assets/images/success-status.png"),
      logo: require("../assets/images/main-logo-white.png"),
      title: "for reaching out.",
      message: "Your request has been received and is being processed. A confirmation email is on its way. For urgent matters, feel free to contact us directly.",
      StatusCode : "200",
      btn1Class: "btn btn-white outline",
      btn2Class: "btn btn-success",
      btn1Text: "return to homepage",
      btn2Text: "explore our menu"
    }
  };

  const config = statusConfig[status] || statusConfig["404"];

  return (
    <section className="error-page-section">
      <div className="error-page">
        <img src={config.logo} alt="" className="error-page-logo" />
        <div className={config.StatusCode === "200" ? "error-page-content content-opacity" : "error-page-content"}>
          <div className="error-text-logo-container">
            <img src={config.Status} alt="" className="error-text-logo" />
            <h1 className={config.StatusCode === "200" ? "success-heading" : "not-found-heading"}>{config.title}</h1>
            <p className={config.StatusCode === "200" ? "success-text" : "not-found-text"}>{config.message}</p>
          </div>

          <div className="error-page-btn">
            <Link className={config.btn1Class} to={"/"}>
              {config.btn1Text}
            </Link>
            <Link className={config.btn2Class} to={status === "success" ? "/order" : "/menu"}>
              {config.btn2Text}
            </Link>
          </div>
        </div>
        <div className="error-image">
          <img src={config.image} alt="" />
        </div>
      </div>
    </section>
  );
}

export default StatusPage;